import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const WhoWhatWear: Site = {
  id: 'whowhatwear',
  logo: 'svg/whowhatwear.svg',
  label: 'Whowhatwear',
  analyticsName: 'whowhatwear',
  hostname: 'whowhatwear.com',
  platform: 'progressive',
  selector: `${progressiveVanillaSelector}, #mainarticle a`,
};
